module.exports = __webpack_public_path__ + "media/images/job-bg-d91b4a77696844b72712fb98e1c17ad7.jpg";